import { render } from "./chart-sankey.vue?vue&type=template&id=2655dd85"
import script from "./chart-sankey.vue?vue&type=script&lang=js"
export * from "./chart-sankey.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__